module.exports = __webpack_public_path__ + "static/media/internal_env_4_media_2.b92a73f5.webp";